import omit from 'lodash/omit';
import branch from 'recompose/branch';
import mapProps from 'recompose/mapProps';
import renderComponent from 'recompose/renderComponent';
import Loading from '../main/customers/customersList/loading';

const withLoader = branch(
  props => props.showLoading,
  renderComponent(Loading),
  mapProps(props => omit(props, ['showLoading']))
);

export default withLoader;
